// extracted by mini-css-extract-plugin
export var btn = "X_mB y_tQ y_tr d_bz d_bP d_bD d_dw";
export var full = "X_yW d_w d_H";
export var hoverStyle = "X_mF";
export var zoom = "X_mG";